import React from 'react'
import { format } from 'date-fns'
import { Button } from 'antd'
import { useI18n } from 'contexts/AuthContext'
import { getDeviceType, toDate } from 'utils/basic'
import { getHealthieHost } from 'apis/formatUrl'
import googleIcon from 'static/img/ic-google.svg'
import appleIcon from 'static/img/ic-apple.svg'

import classes from './index.module.scss'

const ConfirmedAppointmentContent = (props) => {
  const {
    title,
    subtitle,
    bookedAppointment,
    icon,
    showNextButton,
    onClickNext,
  } = props
  const { i18n, dateFnsLocale } = useI18n()

  const appointmentDuration =
    (toDate(bookedAppointment.end) - toDate(bookedAppointment.start)) /
    1000 /
    60

  const deviceType = getDeviceType()
  const isIOS = deviceType === 'iOS'
  const isAndroid = deviceType === 'Android'

  return (
    <div className={classes.style}>
      <img
        src={icon}
        alt=''
        className='top-icon'
        style={{ marginTop: '24px', height: '60px' }}
      />
      <div className='title' style={{ marginTop: '16px' }}>
        {title}
      </div>
      <div
        className='subtitle'
        style={{ marginBottom: '16px', marginTop: '2px' }}
      >
        {subtitle}
      </div>

      <div
        className='appointment-sec'
        style={{ backgroundColor: '#FFFFFF', paddingTop: '0px' }}
      >
        <div
          className='appointment-time'
          style={{ lineHeight: '120%', marginBottom: '24px' }}
        >
          {format(toDate(bookedAppointment.start), `EEE, MMM d, yyyy`, {
            locale: dateFnsLocale,
          })}
          <br />
          {i18n('at')}{' '}
          {format(toDate(bookedAppointment.start), `h:mm a`, {
            locale: dateFnsLocale,
          })}
        </div>
        <div className='appointment-session'>
          <span>
            {i18n(
              `${
                bookedAppointment.appointment_type?.name ||
                'Introductory Session'
              }`
            )}
          </span>
          <span> </span>
          <span>{i18n(`({0} mins)`, appointmentDuration)}</span>
        </div>
      </div>
      <div className='appointment-sec'>
        <div className='appointment-add-calendar'>
          {i18n('Add to your calendar')}
        </div>
        <div className='appointment-add-calendar-btn'>
          <Button
            className='add-calendar-btn full-width-btn m-t-16'
            onClick={() => {
              const calExportId = btoa(
                `${bookedAppointment.id}:${bookedAppointment.appointment_type.id}:${bookedAppointment.patientEmail}`
              )
              window.open(
                `${getHealthieHost()}appointments/add_to_cal/${
                  bookedAppointment.id
                }.ics?cal_type=ical&cal_export_id=${calExportId}`,
                '_blank'
              )
            }}
            hidden={isAndroid}
          >
            <img src={appleIcon} alt='' />
            APPLE
          </Button>
          <Button
            className='add-calendar-btn full-width-btn m-t-16'
            onClick={() => {
              window.open(bookedAppointment.add_to_gcal_link, '_blank')
            }}
            hidden={isIOS}
          >
            <img src={googleIcon} alt='' />
            GOOGLE
          </Button>
        </div>
      </div>

      {showNextButton ? (
        <Button className='btn-primary next-btn' onClick={onClickNext}>
          {i18n('Next')}
        </Button>
      ) : (
        <button className='back-to-fiton-care' onClick={onClickNext}>
          {i18n('Back to FitOn Care')}
        </button>
      )}
    </div>
  )
}

export default ConfirmedAppointmentContent
